import React from 'react'
import AccessTimeIcon from "@mui/icons-material/AccessTime";

function TimeClockUnscheduledShiftCard(props) {
  return (
    <div className="relative w-[275px] bg-gray-50 rounded-2xl px-5 py-4">
      <div className={`flex flex-row items-center ${!props.isClockedIn ? 'mb-3' : ''}`}>
        <AccessTimeIcon sx={{ color: "#6b7280", fontSize: 24 }} />
        <p className="text-gray-700 font-semibold ml-2">
          No Scheduled Shift
        </p>
      </div>
      {!props.isClockedIn && (
        <p className="text-gray-500 text-sm">
          You can still clock in if you have manager approval
        </p>
      )}
    </div>
  )
}

export default TimeClockUnscheduledShiftCard
